import at, { useContext as St, createContext as Jt, useRef as ne, forwardRef as _t, useMemo as re, cloneElement as Ve, Fragment as er, useState as F, useCallback as P, isValidElement as tr, useId as Ge, useEffect as ce, useLayoutEffect as Ct } from "react";
import { j as m } from "./react-944c88e2.js";
import { m as Q } from "./lodash.mergewith-9d927056.js";
import { ThemeContext as rr, keyframes as Ce } from "@emotion/react";
import { g as nr, c as oe, u as or, m as le, a as Pe, b as ke, d as ar, e as ir } from "./chakraReact-cc461a14.js";
import { t as sr } from "./@zag-js-985153e8.js";
import { AnimatePresence as lr, motion as cr } from "framer-motion";
import { i as dr } from "./react-fast-compare-e81d3847.js";
import it from "@emotion/styled";
function He() {
  const e = St(
    rr
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
var It = Jt({});
It.displayName = "ColorModeContext";
function wt() {
  const e = St(It);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
function ur() {
  const e = wt(), t = He();
  return { ...e, theme: t };
}
function pr(e, t, r) {
  var n, o;
  if (t == null)
    return t;
  const i = (s) => {
    var d, l;
    return (l = (d = e.__breakpoints) == null ? void 0 : d.asArray) == null ? void 0 : l[s];
  };
  return (o = (n = i(t)) != null ? n : i(r)) != null ? o : r;
}
function fr(e, t, r) {
  var n, o;
  if (t == null)
    return t;
  const i = (s) => {
    var d, l;
    return (l = (d = e.__cssMap) == null ? void 0 : d[s]) == null ? void 0 : l.value;
  };
  return (o = (n = i(t)) != null ? n : i(r)) != null ? o : r;
}
function oa(e, t, r) {
  const n = He();
  return Tt(e, t, r)(n);
}
function Tt(e, t, r) {
  const n = Array.isArray(t) ? t : [t], o = Array.isArray(r) ? r : [r];
  return (i) => {
    const s = o.filter(Boolean), d = n.map((l, u) => {
      var c, p;
      if (e === "breakpoints")
        return pr(i, l, (c = s[u]) != null ? c : l);
      const h = `${e}.${l}`;
      return fr(i, h, (p = s[u]) != null ? p : l);
    });
    return Array.isArray(t) ? d : d[0];
  };
}
var M = (...e) => e.filter(Boolean).join(" ");
function hr() {
  return process.env.NODE_ENV !== "production";
}
function te(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !Array.isArray(e);
}
var he = (e) => {
  const { condition: t, message: r } = e;
  t && hr() && console.warn(r);
};
function ae(e, ...t) {
  return mr(e) ? e(...t) : e;
}
var mr = (e) => typeof e == "function", _ = (e) => e ? "" : void 0, Ee = (e) => e ? !0 : void 0;
function L(...e) {
  return function(r) {
    e.some((n) => (n == null || n(r), r == null ? void 0 : r.defaultPrevented));
  };
}
function gr(...e) {
  return function(r) {
    e.forEach((n) => {
      n == null || n(r);
    });
  };
}
var br = (e) => /!(important)?$/.test(e), st = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, vr = (e, t) => (r) => {
  const n = String(t), o = br(n), i = st(n), s = e ? `${e}.${i}` : i;
  let d = te(r.__cssMap) && s in r.__cssMap ? r.__cssMap[s].varRef : t;
  return d = st(d), o ? `${d} !important` : d;
};
function qe(e) {
  const { scale: t, transform: r, compose: n } = e;
  return (i, s) => {
    var d;
    const l = vr(t, i)(s);
    let u = (d = r == null ? void 0 : r(l, s)) != null ? d : l;
    return n && (u = n(u, s)), u;
  };
}
var ve = (...e) => (t) => e.reduce((r, n) => n(r), t);
function q(e, t) {
  return (r) => {
    const n = { property: r, scale: e };
    return n.transform = qe({
      scale: e,
      transform: t
    }), n;
  };
}
var yr = ({ rtl: e, ltr: t }) => (r) => r.direction === "rtl" ? e : t;
function kr(e) {
  const { property: t, scale: r, transform: n } = e;
  return {
    scale: r,
    property: yr(t),
    transform: r ? qe({
      scale: r,
      compose: n
    }) : n
  };
}
var Rt = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function xr() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...Rt
  ].join(" ");
}
function Sr() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...Rt
  ].join(" ");
}
var _r = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, Cr = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function Ir(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var wr = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, Oe = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, Tr = new Set(Object.values(Oe)), $e = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), Rr = (e) => e.trim();
function Br(e, t) {
  if (e == null || $e.has(e))
    return e;
  if (!(De(e) || $e.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), i = o == null ? void 0 : o[1], s = o == null ? void 0 : o[2];
  if (!i || !s)
    return e;
  const d = i.includes("-gradient") ? i : `${i}-gradient`, [l, ...u] = s.split(",").map(Rr).filter(Boolean);
  if ((u == null ? void 0 : u.length) === 0)
    return e;
  const c = l in Oe ? Oe[l] : l;
  u.unshift(c);
  const p = u.map((h) => {
    if (Tr.has(h))
      return h;
    const f = h.indexOf(" "), [g, b] = f !== -1 ? [h.substr(0, f), h.substr(f + 1)] : [h], v = De(b) ? b : b && b.split(" "), y = `colors.${g}`, k = y in t.__cssMap ? t.__cssMap[y].varRef : g;
    return v ? [
      k,
      ...Array.isArray(v) ? v : [v]
    ].join(" ") : k;
  });
  return `${d}(${p.join(", ")})`;
}
var De = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), Pr = (e, t) => Br(e, t ?? {});
function Er(e) {
  return /^var\(--.+\)$/.test(e);
}
var Nr = (e) => {
  const t = parseFloat(e.toString()), r = e.toString().replace(String(t), "");
  return { unitless: !r, value: t, unit: r };
}, K = (e) => (t) => `${e}(${t})`, S = {
  filter(e) {
    return e !== "auto" ? e : _r;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : Cr;
  },
  ring(e) {
    return Ir(S.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? xr() : e === "auto-gpu" ? Sr() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = Nr(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const r = { left: "right", right: "left" };
    return t.direction === "rtl" ? r[e] : e;
  },
  degree(e) {
    if (Er(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: Pr,
  blur: K("blur"),
  opacity: K("opacity"),
  brightness: K("brightness"),
  contrast: K("contrast"),
  dropShadow: K("drop-shadow"),
  grayscale: K("grayscale"),
  hueRotate: (e) => K("hue-rotate")(S.degree(e)),
  invert: K("invert"),
  saturate: K("saturate"),
  sepia: K("sepia"),
  bgImage(e) {
    return e == null || De(e) || $e.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    var t;
    const { space: r, divide: n } = (t = wr[e]) != null ? t : {}, o = { flexDirection: e };
    return r && (o[r] = 1), n && (o[n] = 1), o;
  }
}, a = {
  borderWidths: q("borderWidths"),
  borderStyles: q("borderStyles"),
  colors: q("colors"),
  borders: q("borders"),
  gradients: q("gradients", S.gradient),
  radii: q("radii", S.px),
  space: q("space", ve(S.vh, S.px)),
  spaceT: q("space", ve(S.vh, S.px)),
  degreeT(e) {
    return { property: e, transform: S.degree };
  },
  prop(e, t, r) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: qe({ scale: t, transform: r })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: q("sizes", ve(S.vh, S.px)),
  sizesT: q("sizes", ve(S.vh, S.fraction)),
  shadows: q("shadows"),
  logical: kr,
  blur: q("blur", S.blur)
}, xe = {
  background: a.colors("background"),
  backgroundColor: a.colors("backgroundColor"),
  backgroundImage: a.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: S.bgClip },
  bgSize: a.prop("backgroundSize"),
  bgPosition: a.prop("backgroundPosition"),
  bg: a.colors("background"),
  bgColor: a.colors("backgroundColor"),
  bgPos: a.prop("backgroundPosition"),
  bgRepeat: a.prop("backgroundRepeat"),
  bgAttachment: a.prop("backgroundAttachment"),
  bgGradient: a.gradients("backgroundImage"),
  bgClip: { transform: S.bgClip }
};
Object.assign(xe, {
  bgImage: xe.backgroundImage,
  bgImg: xe.backgroundImage
});
var C = {
  border: a.borders("border"),
  borderWidth: a.borderWidths("borderWidth"),
  borderStyle: a.borderStyles("borderStyle"),
  borderColor: a.colors("borderColor"),
  borderRadius: a.radii("borderRadius"),
  borderTop: a.borders("borderTop"),
  borderBlockStart: a.borders("borderBlockStart"),
  borderTopLeftRadius: a.radii("borderTopLeftRadius"),
  borderStartStartRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: a.radii("borderTopRightRadius"),
  borderStartEndRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: a.borders("borderRight"),
  borderInlineEnd: a.borders("borderInlineEnd"),
  borderBottom: a.borders("borderBottom"),
  borderBlockEnd: a.borders("borderBlockEnd"),
  borderBottomLeftRadius: a.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: a.radii("borderBottomRightRadius"),
  borderLeft: a.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: a.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: a.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: a.borders(["borderLeft", "borderRight"]),
  borderInline: a.borders("borderInline"),
  borderY: a.borders(["borderTop", "borderBottom"]),
  borderBlock: a.borders("borderBlock"),
  borderTopWidth: a.borderWidths("borderTopWidth"),
  borderBlockStartWidth: a.borderWidths("borderBlockStartWidth"),
  borderTopColor: a.colors("borderTopColor"),
  borderBlockStartColor: a.colors("borderBlockStartColor"),
  borderTopStyle: a.borderStyles("borderTopStyle"),
  borderBlockStartStyle: a.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: a.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: a.borderWidths("borderBlockEndWidth"),
  borderBottomColor: a.colors("borderBottomColor"),
  borderBlockEndColor: a.colors("borderBlockEndColor"),
  borderBottomStyle: a.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: a.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: a.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: a.borderWidths("borderInlineStartWidth"),
  borderLeftColor: a.colors("borderLeftColor"),
  borderInlineStartColor: a.colors("borderInlineStartColor"),
  borderLeftStyle: a.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: a.borderStyles("borderInlineStartStyle"),
  borderRightWidth: a.borderWidths("borderRightWidth"),
  borderInlineEndWidth: a.borderWidths("borderInlineEndWidth"),
  borderRightColor: a.colors("borderRightColor"),
  borderInlineEndColor: a.colors("borderInlineEndColor"),
  borderRightStyle: a.borderStyles("borderRightStyle"),
  borderInlineEndStyle: a.borderStyles("borderInlineEndStyle"),
  borderTopRadius: a.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: a.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: a.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: a.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(C, {
  rounded: C.borderRadius,
  roundedTop: C.borderTopRadius,
  roundedTopLeft: C.borderTopLeftRadius,
  roundedTopRight: C.borderTopRightRadius,
  roundedTopStart: C.borderStartStartRadius,
  roundedTopEnd: C.borderStartEndRadius,
  roundedBottom: C.borderBottomRadius,
  roundedBottomLeft: C.borderBottomLeftRadius,
  roundedBottomRight: C.borderBottomRightRadius,
  roundedBottomStart: C.borderEndStartRadius,
  roundedBottomEnd: C.borderEndEndRadius,
  roundedLeft: C.borderLeftRadius,
  roundedRight: C.borderRightRadius,
  roundedStart: C.borderInlineStartRadius,
  roundedEnd: C.borderInlineEndRadius,
  borderStart: C.borderInlineStart,
  borderEnd: C.borderInlineEnd,
  borderTopStartRadius: C.borderStartStartRadius,
  borderTopEndRadius: C.borderStartEndRadius,
  borderBottomStartRadius: C.borderEndStartRadius,
  borderBottomEndRadius: C.borderEndEndRadius,
  borderStartRadius: C.borderInlineStartRadius,
  borderEndRadius: C.borderInlineEndRadius,
  borderStartWidth: C.borderInlineStartWidth,
  borderEndWidth: C.borderInlineEndWidth,
  borderStartColor: C.borderInlineStartColor,
  borderEndColor: C.borderInlineEndColor,
  borderStartStyle: C.borderInlineStartStyle,
  borderEndStyle: C.borderInlineEndStyle
});
var Ar = {
  color: a.colors("color"),
  textColor: a.colors("color"),
  fill: a.colors("fill"),
  stroke: a.colors("stroke")
}, je = {
  boxShadow: a.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: a.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: a.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(je, {
  shadow: je.boxShadow
});
var Or = {
  filter: { transform: S.filter },
  blur: a.blur("--chakra-blur"),
  brightness: a.propT("--chakra-brightness", S.brightness),
  contrast: a.propT("--chakra-contrast", S.contrast),
  hueRotate: a.propT("--chakra-hue-rotate", S.hueRotate),
  invert: a.propT("--chakra-invert", S.invert),
  saturate: a.propT("--chakra-saturate", S.saturate),
  dropShadow: a.propT("--chakra-drop-shadow", S.dropShadow),
  backdropFilter: { transform: S.backdropFilter },
  backdropBlur: a.blur("--chakra-backdrop-blur"),
  backdropBrightness: a.propT(
    "--chakra-backdrop-brightness",
    S.brightness
  ),
  backdropContrast: a.propT("--chakra-backdrop-contrast", S.contrast),
  backdropHueRotate: a.propT(
    "--chakra-backdrop-hue-rotate",
    S.hueRotate
  ),
  backdropInvert: a.propT("--chakra-backdrop-invert", S.invert),
  backdropSaturate: a.propT("--chakra-backdrop-saturate", S.saturate)
}, Se = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: S.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: a.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: a.space("gap"),
  rowGap: a.space("rowGap"),
  columnGap: a.space("columnGap")
};
Object.assign(Se, {
  flexDir: Se.flexDirection
});
var Bt = {
  gridGap: a.space("gridGap"),
  gridColumnGap: a.space("gridColumnGap"),
  gridRowGap: a.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, $r = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: S.outline },
  outlineOffset: !0,
  outlineColor: a.colors("outlineColor")
}, Y = {
  width: a.sizesT("width"),
  inlineSize: a.sizesT("inlineSize"),
  height: a.sizes("height"),
  blockSize: a.sizes("blockSize"),
  boxSize: a.sizes(["width", "height"]),
  minWidth: a.sizes("minWidth"),
  minInlineSize: a.sizes("minInlineSize"),
  minHeight: a.sizes("minHeight"),
  minBlockSize: a.sizes("minBlockSize"),
  maxWidth: a.sizes("maxWidth"),
  maxInlineSize: a.sizes("maxInlineSize"),
  maxHeight: a.sizes("maxHeight"),
  maxBlockSize: a.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var r, n, o;
      return { [`@media screen and (min-width: ${(o = (n = (r = t.__breakpoints) == null ? void 0 : r.get(e)) == null ? void 0 : n.minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var r, n, o;
      return { [`@media screen and (max-width: ${(o = (n = (r = t.__breakpoints) == null ? void 0 : r.get(e)) == null ? void 0 : n._minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: a.propT("float", S.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Y, {
  w: Y.width,
  h: Y.height,
  minW: Y.minWidth,
  maxW: Y.maxWidth,
  minH: Y.minHeight,
  maxH: Y.maxHeight,
  overscroll: Y.overscrollBehavior,
  overscrollX: Y.overscrollBehaviorX,
  overscrollY: Y.overscrollBehaviorY
});
var Dr = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: a.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: a.prop("listStyleImage")
};
function jr(e, t, r, n) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (n = 0; n < o.length && e; n += 1)
    e = e[o[n]];
  return e === void 0 ? r : e;
}
var Fr = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (n, o, i, s) => {
    if (typeof n > "u")
      return e(n, o, i);
    t.has(n) || t.set(n, /* @__PURE__ */ new Map());
    const d = t.get(n);
    if (d.has(o))
      return d.get(o);
    const l = e(n, o, i, s);
    return d.set(o, l), l;
  };
}, Mr = Fr(jr), Lr = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, Wr = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Ne = (e, t, r) => {
  const n = {}, o = Mr(e, t, {});
  for (const i in o)
    i in r && r[i] != null || (n[i] = o[i]);
  return n;
}, zr = {
  srOnly: {
    transform(e) {
      return e === !0 ? Lr : e === "focusable" ? Wr : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, r) => Ne(t, `layerStyles.${e}`, r)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, r) => Ne(t, `textStyles.${e}`, r)
  },
  apply: {
    processResult: !0,
    transform: (e, t, r) => Ne(t, e, r)
  }
}, fe = {
  position: !0,
  pos: a.prop("position"),
  zIndex: a.prop("zIndex", "zIndices"),
  inset: a.spaceT("inset"),
  insetX: a.spaceT(["left", "right"]),
  insetInline: a.spaceT("insetInline"),
  insetY: a.spaceT(["top", "bottom"]),
  insetBlock: a.spaceT("insetBlock"),
  top: a.spaceT("top"),
  insetBlockStart: a.spaceT("insetBlockStart"),
  bottom: a.spaceT("bottom"),
  insetBlockEnd: a.spaceT("insetBlockEnd"),
  left: a.spaceT("left"),
  insetInlineStart: a.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: a.spaceT("right"),
  insetInlineEnd: a.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(fe, {
  insetStart: fe.insetInlineStart,
  insetEnd: fe.insetInlineEnd
});
var Vr = {
  ring: { transform: S.ring },
  ringColor: a.colors("--chakra-ring-color"),
  ringOffset: a.prop("--chakra-ring-offset-width"),
  ringOffsetColor: a.colors("--chakra-ring-offset-color"),
  ringInset: a.prop("--chakra-ring-inset")
}, R = {
  margin: a.spaceT("margin"),
  marginTop: a.spaceT("marginTop"),
  marginBlockStart: a.spaceT("marginBlockStart"),
  marginRight: a.spaceT("marginRight"),
  marginInlineEnd: a.spaceT("marginInlineEnd"),
  marginBottom: a.spaceT("marginBottom"),
  marginBlockEnd: a.spaceT("marginBlockEnd"),
  marginLeft: a.spaceT("marginLeft"),
  marginInlineStart: a.spaceT("marginInlineStart"),
  marginX: a.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: a.spaceT("marginInline"),
  marginY: a.spaceT(["marginTop", "marginBottom"]),
  marginBlock: a.spaceT("marginBlock"),
  padding: a.space("padding"),
  paddingTop: a.space("paddingTop"),
  paddingBlockStart: a.space("paddingBlockStart"),
  paddingRight: a.space("paddingRight"),
  paddingBottom: a.space("paddingBottom"),
  paddingBlockEnd: a.space("paddingBlockEnd"),
  paddingLeft: a.space("paddingLeft"),
  paddingInlineStart: a.space("paddingInlineStart"),
  paddingInlineEnd: a.space("paddingInlineEnd"),
  paddingX: a.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: a.space("paddingInline"),
  paddingY: a.space(["paddingTop", "paddingBottom"]),
  paddingBlock: a.space("paddingBlock")
};
Object.assign(R, {
  m: R.margin,
  mt: R.marginTop,
  mr: R.marginRight,
  me: R.marginInlineEnd,
  marginEnd: R.marginInlineEnd,
  mb: R.marginBottom,
  ml: R.marginLeft,
  ms: R.marginInlineStart,
  marginStart: R.marginInlineStart,
  mx: R.marginX,
  my: R.marginY,
  p: R.padding,
  pt: R.paddingTop,
  py: R.paddingY,
  px: R.paddingX,
  pb: R.paddingBottom,
  pl: R.paddingLeft,
  ps: R.paddingInlineStart,
  paddingStart: R.paddingInlineStart,
  pr: R.paddingRight,
  pe: R.paddingInlineEnd,
  paddingEnd: R.paddingInlineEnd
});
var Gr = {
  textDecorationColor: a.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: a.shadows("textShadow")
}, Hr = {
  clipPath: !0,
  transform: a.propT("transform", S.transform),
  transformOrigin: !0,
  translateX: a.spaceT("--chakra-translate-x"),
  translateY: a.spaceT("--chakra-translate-y"),
  skewX: a.degreeT("--chakra-skew-x"),
  skewY: a.degreeT("--chakra-skew-y"),
  scaleX: a.prop("--chakra-scale-x"),
  scaleY: a.prop("--chakra-scale-y"),
  scale: a.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: a.degreeT("--chakra-rotate")
}, qr = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: a.prop("transitionDuration", "transition.duration"),
  transitionProperty: a.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: a.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, Yr = {
  fontFamily: a.prop("fontFamily", "fonts"),
  fontSize: a.prop("fontSize", "fontSizes", S.px),
  fontWeight: a.prop("fontWeight", "fontWeights"),
  lineHeight: a.prop("lineHeight", "lineHeights"),
  letterSpacing: a.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, Xr = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: a.spaceT("scrollMargin"),
  scrollMarginTop: a.spaceT("scrollMarginTop"),
  scrollMarginBottom: a.spaceT("scrollMarginBottom"),
  scrollMarginLeft: a.spaceT("scrollMarginLeft"),
  scrollMarginRight: a.spaceT("scrollMarginRight"),
  scrollMarginX: a.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: a.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: a.spaceT("scrollPadding"),
  scrollPaddingTop: a.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: a.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: a.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: a.spaceT("scrollPaddingRight"),
  scrollPaddingX: a.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: a.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function Pt(e) {
  return te(e) && e.reference ? e.reference : String(e);
}
var Ie = (e, ...t) => t.map(Pt).join(` ${e} `).replace(/calc/g, ""), lt = (...e) => `calc(${Ie("+", ...e)})`, ct = (...e) => `calc(${Ie("-", ...e)})`, Fe = (...e) => `calc(${Ie("*", ...e)})`, dt = (...e) => `calc(${Ie("/", ...e)})`, ut = (e) => {
  const t = Pt(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : Fe(t, -1);
}, pe = Object.assign(
  (e) => ({
    add: (...t) => pe(lt(e, ...t)),
    subtract: (...t) => pe(ct(e, ...t)),
    multiply: (...t) => pe(Fe(e, ...t)),
    divide: (...t) => pe(dt(e, ...t)),
    negate: () => pe(ut(e)),
    toString: () => e.toString()
  }),
  {
    add: lt,
    subtract: ct,
    multiply: Fe,
    divide: dt,
    negate: ut
  }
);
function Ur(e) {
  const t = parseFloat(e.toString()), r = e.toString().replace(String(t), "");
  return { unitless: !r, value: t, unit: r };
}
function pt(e) {
  if (e == null)
    return e;
  const { unitless: t } = Ur(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
function Kr(e, t) {
  const r = ["@media screen"];
  return e && r.push("and", `(min-width: ${pt(e)})`), t && r.push("and", `(max-width: ${pt(t)})`), r.join(" ");
}
var j = {
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, ee = (e) => Et((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), Z = (e) => Et((t) => e(t, "~ &"), "[data-peer]", ".peer"), Et = (e, ...t) => t.map(e).join(", "), Ye = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: ee(j.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Z(j.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: ee(j.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Z(j.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: ee(j.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Z(j.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: ee(j.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Z(j.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: ee(j.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Z(j.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: ee(j.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Z(j.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: ee(j.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Z(j.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: ee(j.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Z(j.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Z(j.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
}, Zr = Object.keys(
  Ye
);
function Qr(e, t = []) {
  const r = Object.assign({}, e);
  for (const n of t)
    n in r && delete r[n];
  return r;
}
var Xe = Q(
  {},
  xe,
  C,
  Ar,
  Se,
  Y,
  Or,
  Vr,
  $r,
  Bt,
  zr,
  fe,
  je,
  R,
  Xr,
  Yr,
  Gr,
  Hr,
  Dr,
  qr
);
Object.assign({}, R, Y, Se, Bt, fe);
var Jr = [...Object.keys(Xe), ...Zr], en = { ...Xe, ...Ye }, tn = (e) => e in en, rn = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: r, toArrayValue: n, media: o } = t.__breakpoints, i = {};
  for (const s in e) {
    let d = ae(e[s], t);
    if (d == null)
      continue;
    if (d = te(d) && r(d) ? n(d) : d, !Array.isArray(d)) {
      i[s] = d;
      continue;
    }
    const l = d.slice(0, o.length).length;
    for (let u = 0; u < l; u += 1) {
      const c = o == null ? void 0 : o[u];
      if (!c) {
        i[s] = d[u];
        continue;
      }
      i[c] = i[c] || {}, d[u] != null && (i[c][s] = d[u]);
    }
  }
  return i;
};
function nn(e) {
  const t = [];
  let r = "", n = !1;
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    i === "(" ? (n = !0, r += i) : i === ")" ? (n = !1, r += i) : i === "," && !n ? (t.push(r), r = "") : r += i;
  }
  return r = r.trim(), r && t.push(r), t;
}
function on(e) {
  return /^var\(--.+\)$/.test(e);
}
var an = (e, t) => e.startsWith("--") && typeof t == "string" && !on(t), sn = (e, t) => {
  var r, n;
  if (t == null)
    return t;
  const o = (l) => {
    var u, c;
    return (c = (u = e.__cssMap) == null ? void 0 : u[l]) == null ? void 0 : c.varRef;
  }, i = (l) => {
    var u;
    return (u = o(l)) != null ? u : l;
  }, [s, d] = nn(t);
  return t = (n = (r = o(s)) != null ? r : i(d)) != null ? n : i(t), t;
};
function ln(e) {
  const { configs: t = {}, pseudos: r = {}, theme: n } = e, o = (i, s = !1) => {
    var d, l, u;
    const c = ae(i, n), p = rn(c)(n);
    let h = {};
    for (let f in p) {
      const g = p[f];
      let b = ae(g, n);
      f in r && (f = r[f]), an(f, b) && (b = sn(n, b));
      let v = t[f];
      if (v === !0 && (v = { property: f }), te(b)) {
        h[f] = (d = h[f]) != null ? d : {}, h[f] = Q(
          {},
          h[f],
          o(b, !0)
        );
        continue;
      }
      let y = (u = (l = v == null ? void 0 : v.transform) == null ? void 0 : l.call(v, b, n, c)) != null ? u : b;
      y = v != null && v.processResult ? o(y, !0) : y;
      const k = ae(v == null ? void 0 : v.property, n);
      if (!s && (v != null && v.static)) {
        const T = ae(v.static, n);
        h = Q({}, h, T);
      }
      if (k && Array.isArray(k)) {
        for (const T of k)
          h[T] = y;
        continue;
      }
      if (k) {
        k === "&" && te(y) ? h = Q({}, h, y) : h[k] = y;
        continue;
      }
      if (te(y)) {
        h = Q({}, h, y);
        continue;
      }
      h[f] = y;
    }
    return h;
  };
  return o;
}
var cn = (e) => (t) => ln({
  theme: t,
  pseudos: Ye,
  configs: Xe
})(e);
function aa(e) {
  return e;
}
function ia(e) {
  return e;
}
function dn(e, t) {
  if (Array.isArray(e))
    return e;
  if (te(e))
    return t(e);
  if (e != null)
    return [e];
}
function un(e, t) {
  for (let r = t + 1; r < e.length; r++)
    if (e[r] != null)
      return r;
  return -1;
}
function pn(e) {
  const t = e.__breakpoints;
  return function(n, o, i, s) {
    var d, l;
    if (!t)
      return;
    const u = {}, c = dn(i, t.toArrayValue);
    if (!c)
      return u;
    const p = c.length, h = p === 1, f = !!n.parts;
    for (let g = 0; g < p; g++) {
      const b = t.details[g], v = t.details[un(c, g)], y = Kr(b.minW, v == null ? void 0 : v._minW), k = ae((d = n[o]) == null ? void 0 : d[c[g]], s);
      if (k) {
        if (f) {
          (l = n.parts) == null || l.forEach((T) => {
            Q(u, {
              [T]: h ? k[T] : { [y]: k[T] }
            });
          });
          continue;
        }
        if (!f) {
          h ? Q(u, k) : u[y] = k;
          continue;
        }
        u[y] = k;
      }
    }
    return u;
  };
}
function fn(e) {
  return (t) => {
    var r;
    const { variant: n, size: o, theme: i } = t, s = pn(i);
    return Q(
      {},
      ae((r = e.baseStyle) != null ? r : {}, t),
      s(e, "sizes", o, t),
      s(e, "variants", n, t)
    );
  };
}
function ie(e) {
  return Qr(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function I(e, t = {}) {
  let r = !1;
  function n() {
    if (!r) {
      r = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function o(...c) {
    n();
    for (const p of c)
      t[p] = l(p);
    return I(e, t);
  }
  function i(...c) {
    for (const p of c)
      p in t || (t[p] = l(p));
    return I(e, t);
  }
  function s() {
    return Object.fromEntries(
      Object.entries(t).map(([p, h]) => [p, h.selector])
    );
  }
  function d() {
    return Object.fromEntries(
      Object.entries(t).map(([p, h]) => [p, h.className])
    );
  }
  function l(c) {
    const f = `chakra-${(["container", "root"].includes(c ?? "") ? [e] : [e, c]).filter(Boolean).join("__")}`;
    return {
      className: f,
      selector: `.${f}`,
      toString: () => c
    };
  }
  return {
    parts: o,
    toPart: l,
    extend: i,
    selectors: s,
    classnames: d,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
I("accordion").parts("root", "container", "button", "panel").extend("icon");
I("alert").parts("title", "description", "container").extend("icon", "spinner");
I("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
I("breadcrumb").parts("link", "item", "container").extend("separator");
I("button").parts();
I("checkbox").parts("control", "icon", "container").extend("label");
I("progress").parts("track", "filledTrack").extend("label");
I("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
I("editable").parts(
  "preview",
  "input",
  "textarea"
);
I("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
I("formError").parts("text", "icon");
var sa = I("input").parts(
  "addon",
  "field",
  "element",
  "group"
);
I("list").parts("container", "item", "icon");
I("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
I("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
I("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
I("pininput").parts("field");
I("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
I("progress").parts(
  "label",
  "filledTrack",
  "track"
);
I("radio").parts(
  "container",
  "control",
  "label"
);
I("select").parts("field", "icon");
I("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
I("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
I("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
);
I("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
I("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
I("tag").parts(
  "container",
  "label",
  "closeButton"
);
I("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
I("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
function hn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var mn = /* @__PURE__ */ hn();
function gn(e, t) {
  const r = {};
  return Object.keys(e).forEach((n) => {
    t.includes(n) || (r[n] = e[n]);
  }), r;
}
function bn(e, t, r, n) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (n = 0; n < o.length && e; n += 1)
    e = e[o[n]];
  return e === void 0 ? r : e;
}
var vn = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (n, o, i, s) => {
    if (typeof n > "u")
      return e(n, o, i);
    t.has(n) || t.set(n, /* @__PURE__ */ new Map());
    const d = t.get(n);
    if (d.has(o))
      return d.get(o);
    const l = e(n, o, i, s);
    return d.set(o, l), l;
  };
}, yn = vn(bn);
function Nt(e, t) {
  const r = {};
  return Object.keys(e).forEach((n) => {
    const o = e[n];
    t(o, n, e) && (r[n] = o);
  }), r;
}
var At = (e) => Nt(e, (t) => t != null);
function kn(e) {
  return typeof e == "function";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function xn(e, ...t) {
  return kn(e) ? e(...t) : e;
}
function Sn(...e) {
  return function(r) {
    e.some((n) => (n == null || n(r), r == null ? void 0 : r.defaultPrevented));
  };
}
function Ot(e, t = {}) {
  var r;
  const { styleConfig: n, ...o } = t, { theme: i, colorMode: s } = ur(), d = e ? yn(i, `components.${e}`) : void 0, l = n || d, u = Q(
    { theme: i, colorMode: s },
    (r = l == null ? void 0 : l.defaultProps) != null ? r : {},
    At(gn(o, ["children"]))
  ), c = ne({});
  if (l) {
    const h = fn(l)(u);
    dr(c.current, h) || (c.current = h);
  }
  return c.current;
}
function we(e, t = {}) {
  return Ot(e, t);
}
function Te(e, t = {}) {
  return Ot(e, t);
}
var _n = /* @__PURE__ */ new Set([
  ...Jr,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), Cn = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function In(e) {
  return Cn.has(e) || !_n.has(e);
}
function wn(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const r = { ...e };
  for (const n of t)
    if (n != null)
      for (const o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (o in r && delete r[o], r[o] = n[o]);
  return r;
}
function Tn(e) {
  const t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
var ft, Rn = (ft = it.default) != null ? ft : it, Bn = ({ baseStyle: e }) => (t) => {
  const { theme: r, css: n, __css: o, sx: i, ...s } = t, d = Nt(s, (p, h) => tn(h)), l = xn(e, t), u = wn(
    {},
    o,
    l,
    At(d),
    i
  ), c = cn(u)(t.theme);
  return n ? [c, n] : c;
};
function Ae(e, t) {
  const { baseStyle: r, ...n } = t ?? {};
  n.shouldForwardProp || (n.shouldForwardProp = In);
  const o = Bn({ baseStyle: r }), i = Rn(
    e,
    n
  )(o);
  return at.forwardRef(function(l, u) {
    const { colorMode: c, forced: p } = wt();
    return at.createElement(i, {
      ref: u,
      "data-theme": p ? c : void 0,
      ...l
    });
  });
}
function Pn() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Ae, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(t, r, n) {
      return Ae(...n);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(t, r) {
      return e.has(r) || e.set(r, Ae(r)), e.get(r);
    }
  });
}
var w = Pn();
function N(e) {
  return _t(e);
}
var ht = {
  path: /* @__PURE__ */ m.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ m.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ m.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ m.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, $t = N((e, t) => {
  const {
    as: r,
    viewBox: n,
    color: o = "currentColor",
    focusable: i = !1,
    children: s,
    className: d,
    __css: l,
    ...u
  } = e, c = M("chakra-icon", d), p = we("Icon", e), h = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...l,
    ...p
  }, f = {
    ref: t,
    focusable: i,
    className: c,
    __css: h
  }, g = n ?? ht.viewBox;
  if (r && typeof r != "string")
    return /* @__PURE__ */ m.jsx(w.svg, { as: r, ...f, ...u });
  const b = s ?? ht.path;
  return /* @__PURE__ */ m.jsx(w.svg, { verticalAlign: "middle", viewBox: g, ...f, ...u, children: b });
});
$t.displayName = "Icon";
var Dt = N(function(t, r) {
  const {
    templateAreas: n,
    gap: o,
    rowGap: i,
    columnGap: s,
    column: d,
    row: l,
    autoFlow: u,
    autoRows: c,
    templateRows: p,
    autoColumns: h,
    templateColumns: f,
    ...g
  } = t, b = {
    display: "grid",
    gridTemplateAreas: n,
    gridGap: o,
    gridRowGap: i,
    gridColumnGap: s,
    gridAutoColumns: h,
    gridColumn: d,
    gridRow: l,
    gridAutoFlow: u,
    gridAutoRows: c,
    gridTemplateRows: p,
    gridTemplateColumns: f
  };
  return /* @__PURE__ */ m.jsx(w.div, { ref: r, __css: b, ...g });
});
Dt.displayName = "Grid";
function Ue(e, t) {
  return Array.isArray(e) ? e.map((r) => r === null ? null : t(r)) : te(e) ? Object.keys(e).reduce((r, n) => (r[n] = t(e[n]), r), {}) : e != null ? t(e) : null;
}
var En = N(
  function(t, r) {
    const { columns: n, spacingX: o, spacingY: i, spacing: s, minChildWidth: d, ...l } = t, u = He(), c = d ? An(d, u) : On(n);
    return /* @__PURE__ */ m.jsx(
      Dt,
      {
        ref: r,
        gap: s,
        columnGap: o,
        rowGap: i,
        templateColumns: c,
        ...l
      }
    );
  }
);
En.displayName = "SimpleGrid";
function Nn(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function An(e, t) {
  return Ue(e, (r) => {
    const n = Tt("sizes", r, Nn(r))(t);
    return r === null ? null : `repeat(auto-fit, minmax(${n}, 1fr))`;
  });
}
function On(e) {
  return Ue(
    e,
    (t) => t === null ? null : `repeat(${t}, minmax(0, 1fr))`
  );
}
var $n = N(function(t, r) {
  const n = we("Text", t), { className: o, align: i, decoration: s, casing: d, ...l } = ie(t), u = Tn({
    textAlign: t.align,
    textDecoration: t.decoration,
    textTransform: t.casing
  });
  return /* @__PURE__ */ m.jsx(
    w.p,
    {
      ref: r,
      className: M("chakra-text", t.className),
      ...u,
      ...l,
      __css: n
    }
  );
});
$n.displayName = "Text";
var jt = (e) => /* @__PURE__ */ m.jsx(
  w.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
jt.displayName = "StackItem";
function Dn(e) {
  const { spacing: t, direction: r } = e, n = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": Ue(
      r,
      (o) => n[o]
    )
  };
}
var Ke = N((e, t) => {
  const {
    isInline: r,
    direction: n,
    align: o,
    justify: i,
    spacing: s = "0.5rem",
    wrap: d,
    children: l,
    divider: u,
    className: c,
    shouldWrapChildren: p,
    ...h
  } = e, f = r ? "row" : n ?? "column", g = re(
    () => Dn({ spacing: s, direction: f }),
    [s, f]
  ), b = !!u, v = !p && !b, y = re(() => {
    const T = nr(l);
    return v ? T : T.map((A, z) => {
      const V = typeof A.key < "u" ? A.key : z, B = z + 1 === T.length, $ = p ? /* @__PURE__ */ m.jsx(jt, { children: A }, V) : A;
      if (!b)
        return $;
      const W = Ve(
        u,
        {
          __css: g
        }
      ), D = B ? null : W;
      return /* @__PURE__ */ m.jsxs(er, { children: [
        $,
        D
      ] }, V);
    });
  }, [
    u,
    g,
    b,
    v,
    p,
    l
  ]), k = M("chakra-stack", c);
  return /* @__PURE__ */ m.jsx(
    w.div,
    {
      ref: t,
      display: "flex",
      alignItems: o,
      justifyContent: i,
      flexDirection: f,
      flexWrap: d,
      gap: b ? void 0 : s,
      className: k,
      ...h,
      children: y
    }
  );
});
Ke.displayName = "Stack";
var jn = N((e, t) => /* @__PURE__ */ m.jsx(Ke, { align: "center", ...e, direction: "column", ref: t }));
jn.displayName = "VStack";
var Fn = N((e, t) => /* @__PURE__ */ m.jsx(Ke, { align: "center", ...e, direction: "row", ref: t }));
Fn.displayName = "HStack";
var Ft = w("div");
Ft.displayName = "Box";
var Mt = N(function(t, r) {
  const { size: n, centerContent: o = !0, ...i } = t, s = o ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
  return /* @__PURE__ */ m.jsx(
    Ft,
    {
      ref: r,
      boxSize: n,
      __css: {
        ...s,
        flexShrink: 0,
        flexGrow: 0
      },
      ...i
    }
  );
});
Mt.displayName = "Square";
var Mn = N(function(t, r) {
  const { size: n, ...o } = t;
  return /* @__PURE__ */ m.jsx(Mt, { size: n, ref: r, borderRadius: "9999px", ...o });
});
Mn.displayName = "Circle";
var Ln = N(function(t, r) {
  const { direction: n, align: o, justify: i, wrap: s, basis: d, grow: l, shrink: u, ...c } = t, p = {
    display: "flex",
    flexDirection: n,
    alignItems: o,
    justifyContent: i,
    flexWrap: s,
    flexBasis: d,
    flexGrow: l,
    flexShrink: u
  };
  return /* @__PURE__ */ m.jsx(w.div, { ref: r, __css: p, ...c });
});
Ln.displayName = "Flex";
var [la, Wn] = oe({
  strict: !1,
  name: "ButtonGroupContext"
});
function zn(e) {
  const [t, r] = F(!e);
  return { ref: P((i) => {
    i && r(i.tagName === "BUTTON");
  }, []), type: t ? "button" : void 0 };
}
function Me(e) {
  const { children: t, className: r, ...n } = e, o = tr(t) ? Ve(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, i = M("chakra-button__icon", r);
  return /* @__PURE__ */ m.jsx(
    w.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...n,
      className: i,
      children: o
    }
  );
}
Me.displayName = "ButtonIcon";
var Vn = Ce({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Lt = N((e, t) => {
  const r = we("Spinner", e), {
    label: n = "Loading...",
    thickness: o = "2px",
    speed: i = "0.45s",
    emptyColor: s = "transparent",
    className: d,
    ...l
  } = ie(e), u = M("chakra-spinner", d), c = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: s,
    borderLeftColor: s,
    animation: `${Vn} ${i} linear infinite`,
    ...r
  };
  return /* @__PURE__ */ m.jsx(
    w.div,
    {
      ref: t,
      __css: c,
      className: u,
      ...l,
      children: n && /* @__PURE__ */ m.jsx(w.span, { srOnly: !0, children: n })
    }
  );
});
Lt.displayName = "Spinner";
function Le(e) {
  const {
    label: t,
    placement: r,
    spacing: n = "0.5rem",
    children: o = /* @__PURE__ */ m.jsx(Lt, { color: "currentColor", width: "1em", height: "1em" }),
    className: i,
    __css: s,
    ...d
  } = e, l = M("chakra-button__spinner", i), u = r === "start" ? "marginEnd" : "marginStart", c = re(
    () => ({
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute",
      [u]: t ? n : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...s
    }),
    [s, t, u, n]
  );
  return /* @__PURE__ */ m.jsx(w.div, { className: l, ...d, __css: c, children: o });
}
Le.displayName = "ButtonSpinner";
var Gn = N((e, t) => {
  const r = Wn(), n = we("Button", { ...r, ...e }), {
    isDisabled: o = r == null ? void 0 : r.isDisabled,
    isLoading: i,
    isActive: s,
    children: d,
    leftIcon: l,
    rightIcon: u,
    loadingText: c,
    iconSpacing: p = "0.5rem",
    type: h,
    spinner: f,
    spinnerPlacement: g = "start",
    className: b,
    as: v,
    ...y
  } = ie(e), k = re(() => {
    const V = { ...n == null ? void 0 : n._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...n,
      ...!!r && { _focus: V }
    };
  }, [n, r]), { ref: T, type: A } = zn(v), z = { rightIcon: u, leftIcon: l, iconSpacing: p, children: d };
  return /* @__PURE__ */ m.jsxs(
    w.button,
    {
      ref: or(t, T),
      as: v,
      type: h ?? A,
      "data-active": _(s),
      "data-loading": _(i),
      __css: k,
      className: M("chakra-button", b),
      ...y,
      disabled: o || i,
      children: [
        i && g === "start" && /* @__PURE__ */ m.jsx(
          Le,
          {
            className: "chakra-button__spinner--start",
            label: c,
            placement: "start",
            spacing: p,
            children: f
          }
        ),
        i ? c || /* @__PURE__ */ m.jsx(w.span, { opacity: 0, children: /* @__PURE__ */ m.jsx(mt, { ...z }) }) : /* @__PURE__ */ m.jsx(mt, { ...z }),
        i && g === "end" && /* @__PURE__ */ m.jsx(
          Le,
          {
            className: "chakra-button__spinner--end",
            label: c,
            placement: "end",
            spacing: p,
            children: f
          }
        )
      ]
    }
  );
});
Gn.displayName = "Button";
function mt(e) {
  const { leftIcon: t, rightIcon: r, children: n, iconSpacing: o } = e;
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    t && /* @__PURE__ */ m.jsx(Me, { marginEnd: o, children: t }),
    n,
    r && /* @__PURE__ */ m.jsx(Me, { marginStart: o, children: r })
  ] });
}
var [ca, Hn] = oe({
  name: "CheckboxGroupContext",
  strict: !1
});
function qn(e) {
  const [t, r] = F(e), [n, o] = F(!1);
  return e !== t && (o(!0), r(e)), n;
}
function Yn(e) {
  return /* @__PURE__ */ m.jsx(
    w.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...e,
      children: /* @__PURE__ */ m.jsx("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function Xn(e) {
  return /* @__PURE__ */ m.jsx(
    w.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...e,
      children: /* @__PURE__ */ m.jsx("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function Un(e) {
  const { isIndeterminate: t, isChecked: r, ...n } = e, o = t ? Xn : Yn;
  return r || t ? /* @__PURE__ */ m.jsx(
    w.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ m.jsx(o, { ...n })
    }
  ) : null;
}
var [Kn, Zn] = oe({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [Qn, Wt] = oe({
  strict: !1,
  name: "FormControlContext"
});
function Jn(e) {
  const {
    id: t,
    isRequired: r,
    isInvalid: n,
    isDisabled: o,
    isReadOnly: i,
    ...s
  } = e, d = Ge(), l = t || `field-${d}`, u = `${l}-label`, c = `${l}-feedback`, p = `${l}-helptext`, [h, f] = F(!1), [g, b] = F(!1), [v, y] = F(!1), k = P(
    (B = {}, O = null) => ({
      id: p,
      ...B,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: le(O, ($) => {
        $ && b(!0);
      })
    }),
    [p]
  ), T = P(
    (B = {}, O = null) => ({
      ...B,
      ref: O,
      "data-focus": _(v),
      "data-disabled": _(o),
      "data-invalid": _(n),
      "data-readonly": _(i),
      id: B.id !== void 0 ? B.id : u,
      htmlFor: B.htmlFor !== void 0 ? B.htmlFor : l
    }),
    [l, o, v, n, i, u]
  ), A = P(
    (B = {}, O = null) => ({
      id: c,
      ...B,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: le(O, ($) => {
        $ && f(!0);
      }),
      "aria-live": "polite"
    }),
    [c]
  ), z = P(
    (B = {}, O = null) => ({
      ...B,
      ...s,
      ref: O,
      role: "group",
      "data-focus": _(v),
      "data-disabled": _(o),
      "data-invalid": _(n),
      "data-readonly": _(i)
    }),
    [s, o, v, n, i]
  ), V = P(
    (B = {}, O = null) => ({
      ...B,
      ref: O,
      role: "presentation",
      "aria-hidden": !0,
      children: B.children || "*"
    }),
    []
  );
  return {
    isRequired: !!r,
    isInvalid: !!n,
    isReadOnly: !!i,
    isDisabled: !!o,
    isFocused: !!v,
    onFocus: () => y(!0),
    onBlur: () => y(!1),
    hasFeedbackText: h,
    setHasFeedbackText: f,
    hasHelpText: g,
    setHasHelpText: b,
    id: l,
    labelId: u,
    feedbackId: c,
    helpTextId: p,
    htmlProps: s,
    getHelpTextProps: k,
    getErrorMessageProps: A,
    getRootProps: z,
    getLabelProps: T,
    getRequiredIndicatorProps: V
  };
}
var eo = N(
  function(t, r) {
    const n = Te("Form", t), o = ie(t), {
      getRootProps: i,
      htmlProps: s,
      ...d
    } = Jn(o), l = M("chakra-form-control", t.className);
    return /* @__PURE__ */ m.jsx(Qn, { value: d, children: /* @__PURE__ */ m.jsx(Kn, { value: n, children: /* @__PURE__ */ m.jsx(
      w.div,
      {
        ...i({}, r),
        className: l,
        __css: n.container
      }
    ) }) });
  }
);
eo.displayName = "FormControl";
var to = N(
  function(t, r) {
    const n = Wt(), o = Zn(), i = M("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ m.jsx(
      w.div,
      {
        ...n == null ? void 0 : n.getHelpTextProps(t, r),
        __css: o.helperText,
        className: i
      }
    );
  }
);
to.displayName = "FormHelperText";
function ro(e) {
  const { isDisabled: t, isInvalid: r, isReadOnly: n, isRequired: o, ...i } = zt(e);
  return {
    ...i,
    disabled: t,
    readOnly: n,
    required: o,
    "aria-invalid": Ee(r),
    "aria-required": Ee(o),
    "aria-readonly": Ee(n)
  };
}
function zt(e) {
  var t, r, n;
  const o = Wt(), {
    id: i,
    disabled: s,
    readOnly: d,
    required: l,
    isRequired: u,
    isInvalid: c,
    isReadOnly: p,
    isDisabled: h,
    onFocus: f,
    onBlur: g,
    ...b
  } = e, v = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return o != null && o.hasFeedbackText && (o != null && o.isInvalid) && v.push(o.feedbackId), o != null && o.hasHelpText && v.push(o.helpTextId), {
    ...b,
    "aria-describedby": v.join(" ") || void 0,
    id: i ?? (o == null ? void 0 : o.id),
    isDisabled: (t = s ?? h) != null ? t : o == null ? void 0 : o.isDisabled,
    isReadOnly: (r = d ?? p) != null ? r : o == null ? void 0 : o.isReadOnly,
    isRequired: (n = l ?? u) != null ? n : o == null ? void 0 : o.isRequired,
    isInvalid: c ?? (o == null ? void 0 : o.isInvalid),
    onFocus: L(o == null ? void 0 : o.onFocus, f),
    onBlur: L(o == null ? void 0 : o.onBlur, g)
  };
}
var no = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
function oo(e, t = []) {
  const r = Object.assign({}, e);
  for (const n of t)
    n in r && delete r[n];
  return r;
}
function ao(e = {}) {
  const t = zt(e), {
    isDisabled: r,
    isReadOnly: n,
    isRequired: o,
    isInvalid: i,
    id: s,
    onBlur: d,
    onFocus: l,
    "aria-describedby": u
  } = t, {
    defaultChecked: c,
    isChecked: p,
    isFocusable: h,
    onChange: f,
    isIndeterminate: g,
    name: b,
    value: v,
    tabIndex: y = void 0,
    "aria-label": k,
    "aria-labelledby": T,
    "aria-invalid": A,
    ...z
  } = e, V = oo(z, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]), B = Pe(f), O = Pe(d), $ = Pe(l), [W, D] = F(!1), [J, me] = F(!1), [de, Je] = F(!1), [ue, se] = F(!1);
  ce(() => sr(D), []);
  const X = ne(null), [et, qt] = F(!0), [Yt, ge] = F(!!c), Be = p !== void 0, G = Be ? p : Yt, tt = P(
    (x) => {
      if (n || r) {
        x.preventDefault();
        return;
      }
      Be || ge(G ? x.target.checked : g ? !0 : x.target.checked), B == null || B(x);
    },
    [
      n,
      r,
      G,
      Be,
      g,
      B
    ]
  );
  ke(() => {
    X.current && (X.current.indeterminate = !!g);
  }, [g]), ar(() => {
    r && me(!1);
  }, [r, me]), ke(() => {
    const x = X.current;
    if (!(x != null && x.form))
      return;
    const H = () => {
      ge(!!c);
    };
    return x.form.addEventListener("reset", H), () => {
      var U;
      return (U = x.form) == null ? void 0 : U.removeEventListener("reset", H);
    };
  }, []);
  const rt = r && !h, nt = P(
    (x) => {
      x.key === " " && se(!0);
    },
    [se]
  ), ot = P(
    (x) => {
      x.key === " " && se(!1);
    },
    [se]
  );
  ke(() => {
    if (!X.current)
      return;
    X.current.checked !== G && ge(X.current.checked);
  }, [X.current]);
  const Xt = P(
    (x = {}, H = null) => {
      const U = (be) => {
        J && be.preventDefault(), se(!0);
      };
      return {
        ...x,
        ref: H,
        "data-active": _(ue),
        "data-hover": _(de),
        "data-checked": _(G),
        "data-focus": _(J),
        "data-focus-visible": _(J && W),
        "data-indeterminate": _(g),
        "data-disabled": _(r),
        "data-invalid": _(i),
        "data-readonly": _(n),
        "aria-hidden": !0,
        onMouseDown: L(x.onMouseDown, U),
        onMouseUp: L(x.onMouseUp, () => se(!1)),
        onMouseEnter: L(
          x.onMouseEnter,
          () => Je(!0)
        ),
        onMouseLeave: L(
          x.onMouseLeave,
          () => Je(!1)
        )
      };
    },
    [
      ue,
      G,
      r,
      J,
      W,
      de,
      g,
      i,
      n
    ]
  ), Ut = P(
    (x = {}, H = null) => ({
      ...x,
      ref: H,
      "data-active": _(ue),
      "data-hover": _(de),
      "data-checked": _(G),
      "data-focus": _(J),
      "data-focus-visible": _(J && W),
      "data-indeterminate": _(g),
      "data-disabled": _(r),
      "data-invalid": _(i),
      "data-readonly": _(n)
    }),
    [
      ue,
      G,
      r,
      J,
      W,
      de,
      g,
      i,
      n
    ]
  ), Kt = P(
    (x = {}, H = null) => ({
      ...V,
      ...x,
      ref: le(H, (U) => {
        U && qt(U.tagName === "LABEL");
      }),
      onClick: L(x.onClick, () => {
        var U;
        et || ((U = X.current) == null || U.click(), requestAnimationFrame(() => {
          var be;
          (be = X.current) == null || be.focus({ preventScroll: !0 });
        }));
      }),
      "data-disabled": _(r),
      "data-checked": _(G),
      "data-invalid": _(i)
    }),
    [V, r, G, i, et]
  ), Zt = P(
    (x = {}, H = null) => ({
      ...x,
      ref: le(X, H),
      type: "checkbox",
      name: b,
      value: v,
      id: s,
      tabIndex: y,
      onChange: L(x.onChange, tt),
      onBlur: L(
        x.onBlur,
        O,
        () => me(!1)
      ),
      onFocus: L(
        x.onFocus,
        $,
        () => me(!0)
      ),
      onKeyDown: L(x.onKeyDown, nt),
      onKeyUp: L(x.onKeyUp, ot),
      required: o,
      checked: G,
      disabled: rt,
      readOnly: n,
      "aria-label": k,
      "aria-labelledby": T,
      "aria-invalid": A ? !!A : i,
      "aria-describedby": u,
      "aria-disabled": r,
      style: no
    }),
    [
      b,
      v,
      s,
      tt,
      O,
      $,
      nt,
      ot,
      o,
      G,
      rt,
      n,
      k,
      T,
      A,
      i,
      u,
      r,
      y
    ]
  ), Qt = P(
    (x = {}, H = null) => ({
      ...x,
      ref: H,
      onMouseDown: L(x.onMouseDown, io),
      "data-disabled": _(r),
      "data-checked": _(G),
      "data-invalid": _(i)
    }),
    [G, r, i]
  );
  return {
    state: {
      isInvalid: i,
      isFocused: J,
      isChecked: G,
      isActive: ue,
      isHovered: de,
      isIndeterminate: g,
      isDisabled: r,
      isReadOnly: n,
      isRequired: o
    },
    getRootProps: Kt,
    getCheckboxProps: Xt,
    getIndicatorProps: Ut,
    getInputProps: Zt,
    getLabelProps: Qt,
    htmlProps: V
  };
}
function io(e) {
  e.preventDefault(), e.stopPropagation();
}
var so = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
}, lo = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
}, co = Ce({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
}), uo = Ce({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
}), po = Ce({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
}), fo = N(function(t, r) {
  const n = Hn(), o = { ...n, ...t }, i = Te("Checkbox", o), s = ie(t), {
    spacing: d = "0.5rem",
    className: l,
    children: u,
    iconColor: c,
    iconSize: p,
    icon: h = /* @__PURE__ */ m.jsx(Un, {}),
    isChecked: f,
    isDisabled: g = n == null ? void 0 : n.isDisabled,
    onChange: b,
    inputProps: v,
    ...y
  } = s;
  let k = f;
  n != null && n.value && s.value && (k = n.value.includes(s.value));
  let T = b;
  n != null && n.onChange && s.value && (T = gr(n.onChange, b));
  const {
    state: A,
    getInputProps: z,
    getCheckboxProps: V,
    getLabelProps: B,
    getRootProps: O
  } = ao({
    ...y,
    isDisabled: g,
    isChecked: k,
    onChange: T
  }), $ = qn(A.isChecked), W = re(
    () => ({
      animation: $ ? A.isIndeterminate ? `${uo} 20ms linear, ${po} 200ms linear` : `${co} 200ms linear` : void 0,
      fontSize: p,
      color: c,
      ...i.icon
    }),
    [c, p, $, A.isIndeterminate, i.icon]
  ), D = Ve(h, {
    __css: W,
    isIndeterminate: A.isIndeterminate,
    isChecked: A.isChecked
  });
  return /* @__PURE__ */ m.jsxs(
    w.label,
    {
      __css: { ...lo, ...i.container },
      className: M("chakra-checkbox", l),
      ...O(),
      children: [
        /* @__PURE__ */ m.jsx(
          "input",
          {
            className: "chakra-checkbox__input",
            ...z(v, r)
          }
        ),
        /* @__PURE__ */ m.jsx(
          w.span,
          {
            __css: { ...so, ...i.control },
            className: "chakra-checkbox__control",
            ...V(),
            children: D
          }
        ),
        u && /* @__PURE__ */ m.jsx(
          w.span,
          {
            className: "chakra-checkbox__label",
            ...B(),
            __css: {
              marginStart: d,
              ...i.label
            },
            children: u
          }
        )
      ]
    }
  );
});
fo.displayName = "Checkbox";
var Vt = N(function(t, r) {
  const { htmlSize: n, ...o } = t, i = Te("Input", o), s = ie(o), d = ro(s), l = M("chakra-input", t.className);
  return /* @__PURE__ */ m.jsx(
    w.input,
    {
      size: n,
      ...d,
      __css: i.field,
      ref: r,
      className: l
    }
  );
});
Vt.displayName = "Input";
Vt.id = "Input";
var We = N(function(t, r) {
  const { htmlWidth: n, htmlHeight: o, alt: i, ...s } = t;
  return /* @__PURE__ */ m.jsx("img", { width: n, height: o, ref: r, alt: i, ...s });
});
We.displayName = "NativeImage";
function ho(e) {
  const {
    loading: t,
    src: r,
    srcSet: n,
    onLoad: o,
    onError: i,
    crossOrigin: s,
    sizes: d,
    ignoreFallback: l
  } = e, [u, c] = F("pending");
  ce(() => {
    c(r ? "loading" : "pending");
  }, [r]);
  const p = ne(), h = P(() => {
    if (!r)
      return;
    f();
    const g = new Image();
    g.src = r, s && (g.crossOrigin = s), n && (g.srcset = n), d && (g.sizes = d), t && (g.loading = t), g.onload = (b) => {
      f(), c("loaded"), o == null || o(b);
    }, g.onerror = (b) => {
      f(), c("failed"), i == null || i(b);
    }, p.current = g;
  }, [r, s, n, d, o, i, t]), f = () => {
    p.current && (p.current.onload = null, p.current.onerror = null, p.current = null);
  };
  return ke(() => {
    if (!l)
      return u === "loading" && h(), () => {
        f();
      };
  }, [u, h, l]), l ? "loaded" : u;
}
var mo = (e, t) => e !== "loaded" && t === "beforeLoadOrError" || e === "failed" && t === "onError";
function go(e, t = []) {
  const r = Object.assign({}, e);
  for (const n of t)
    n in r && delete r[n];
  return r;
}
var bo = N(function(t, r) {
  const {
    fallbackSrc: n,
    fallback: o,
    src: i,
    srcSet: s,
    align: d,
    fit: l,
    loading: u,
    ignoreFallback: c,
    crossOrigin: p,
    fallbackStrategy: h = "beforeLoadOrError",
    referrerPolicy: f,
    ...g
  } = t, b = n !== void 0 || o !== void 0, v = u != null || // use can opt out of fallback image
  c || // if the user doesn't provide any kind of fallback we should ignore it
  !b, y = ho({
    ...t,
    crossOrigin: p,
    ignoreFallback: v
  }), k = mo(y, h), T = {
    ref: r,
    objectFit: l,
    objectPosition: d,
    ...v ? g : go(g, ["onError", "onLoad"])
  };
  return k ? o || /* @__PURE__ */ m.jsx(
    w.img,
    {
      as: We,
      className: "chakra-image__placeholder",
      src: n,
      ...T
    }
  ) : /* @__PURE__ */ m.jsx(
    w.img,
    {
      as: We,
      src: i,
      srcSet: s,
      crossOrigin: p,
      loading: u,
      referrerPolicy: f,
      className: "chakra-image",
      ...T
    }
  );
});
bo.displayName = "Image";
var vo = mn ? Ct : ce;
function gt(e, t = []) {
  const r = ne(e);
  return vo(() => {
    r.current = e;
  }), P((...n) => {
    var o;
    return (o = r.current) == null ? void 0 : o.call(r, ...n);
  }, t);
}
function yo(e, t) {
  const r = Ge();
  return re(
    () => e || [t, r].filter(Boolean).join("-"),
    [e, t, r]
  );
}
function ko(e, t) {
  const r = e !== void 0;
  return [r, r && typeof e < "u" ? e : t];
}
function da(e = {}) {
  const {
    onClose: t,
    onOpen: r,
    isOpen: n,
    id: o
  } = e, i = gt(r), s = gt(t), [d, l] = F(e.defaultIsOpen || !1), [u, c] = ko(n, d), p = yo(o, "disclosure"), h = P(() => {
    u || l(!1), s == null || s();
  }, [u, s]), f = P(() => {
    u || l(!0), i == null || i();
  }, [u, i]), g = P(() => {
    (c ? h : f)();
  }, [c, f, h]);
  return {
    isOpen: !!c,
    onOpen: f,
    onClose: h,
    onToggle: g,
    isControlled: u,
    getButtonProps: (b = {}) => ({
      ...b,
      "aria-expanded": c,
      "aria-controls": p,
      onClick: Sn(b.onClick, g)
    }),
    getDisclosureProps: (b = {}) => ({
      ...b,
      hidden: !c,
      id: p
    })
  };
}
function ua(e) {
  const t = ne(null);
  return t.current === null && (t.current = typeof e == "function" ? e() : e), t.current;
}
var xo = Object.defineProperty, So = (e, t, r) => t in e ? xo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, E = (e, t, r) => (So(e, typeof t != "symbol" ? t + "" : t, r), r);
function bt(e) {
  return e.sort((t, r) => {
    const n = t.compareDocumentPosition(r);
    if (n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (n & Node.DOCUMENT_POSITION_DISCONNECTED || n & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
var _o = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function vt(e, t, r) {
  let n = e + 1;
  return r && n >= t && (n = 0), n;
}
function yt(e, t, r) {
  let n = e - 1;
  return r && n < 0 && (n = t), n;
}
var ze = typeof window < "u" ? Ct : ce, _e = (e) => e, Co = class {
  constructor() {
    E(this, "descendants", /* @__PURE__ */ new Map()), E(this, "register", (e) => {
      if (e != null)
        return _o(e) ? this.registerNode(e) : (t) => {
          this.registerNode(t, e);
        };
    }), E(this, "unregister", (e) => {
      this.descendants.delete(e);
      const t = bt(Array.from(this.descendants.keys()));
      this.assignIndex(t);
    }), E(this, "destroy", () => {
      this.descendants.clear();
    }), E(this, "assignIndex", (e) => {
      this.descendants.forEach((t) => {
        const r = e.indexOf(t.node);
        t.index = r, t.node.dataset.index = t.index.toString();
      });
    }), E(this, "count", () => this.descendants.size), E(this, "enabledCount", () => this.enabledValues().length), E(this, "values", () => Array.from(this.descendants.values()).sort((t, r) => t.index - r.index)), E(this, "enabledValues", () => this.values().filter((e) => !e.disabled)), E(this, "item", (e) => {
      if (this.count() !== 0)
        return this.values()[e];
    }), E(this, "enabledItem", (e) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[e];
    }), E(this, "first", () => this.item(0)), E(this, "firstEnabled", () => this.enabledItem(0)), E(this, "last", () => this.item(this.descendants.size - 1)), E(this, "lastEnabled", () => {
      const e = this.enabledValues().length - 1;
      return this.enabledItem(e);
    }), E(this, "indexOf", (e) => {
      var t, r;
      return e && (r = (t = this.descendants.get(e)) == null ? void 0 : t.index) != null ? r : -1;
    }), E(this, "enabledIndexOf", (e) => e == null ? -1 : this.enabledValues().findIndex((t) => t.node.isSameNode(e))), E(this, "next", (e, t = !0) => {
      const r = vt(e, this.count(), t);
      return this.item(r);
    }), E(this, "nextEnabled", (e, t = !0) => {
      const r = this.item(e);
      if (!r)
        return;
      const n = this.enabledIndexOf(r.node), o = vt(
        n,
        this.enabledCount(),
        t
      );
      return this.enabledItem(o);
    }), E(this, "prev", (e, t = !0) => {
      const r = yt(e, this.count() - 1, t);
      return this.item(r);
    }), E(this, "prevEnabled", (e, t = !0) => {
      const r = this.item(e);
      if (!r)
        return;
      const n = this.enabledIndexOf(r.node), o = yt(
        n,
        this.enabledCount() - 1,
        t
      );
      return this.enabledItem(o);
    }), E(this, "registerNode", (e, t) => {
      if (!e || this.descendants.has(e))
        return;
      const r = Array.from(this.descendants.keys()).concat(e), n = bt(r);
      t != null && t.disabled && (t.disabled = !!t.disabled);
      const o = { node: e, index: -1, ...t };
      this.descendants.set(e, o), this.assignIndex(n);
    });
  }
};
function Io() {
  const e = ne(new Co());
  return ze(() => () => e.current.destroy()), e.current;
}
var [wo, Gt] = oe({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function To(e) {
  const t = Gt(), [r, n] = F(-1), o = ne(null);
  ze(() => () => {
    o.current && t.unregister(o.current);
  }, []), ze(() => {
    if (!o.current)
      return;
    const s = Number(o.current.dataset.index);
    r != s && !Number.isNaN(s) && n(s);
  });
  const i = _e(e ? t.register(e) : t.register);
  return {
    descendants: t,
    index: r,
    enabledIndex: t.enabledIndexOf(o.current),
    register: le(i, o)
  };
}
function Ro() {
  return [
    _e(wo),
    () => _e(Gt()),
    () => Io(),
    (o) => To(o)
  ];
}
var [Bo, Re] = oe({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
}), [Po, Ze] = oe({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
}), [
  Eo,
  pa,
  No,
  Ao
] = Ro(), Oo = N(
  function(t, r) {
    const { getButtonProps: n } = Ze(), o = n(t, r), s = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: 0,
      ...Re().button
    };
    return /* @__PURE__ */ m.jsx(
      w.button,
      {
        ...o,
        className: M("chakra-accordion__button", t.className),
        __css: s
      }
    );
  }
);
Oo.displayName = "AccordionButton";
function $o(e) {
  const {
    onChange: t,
    defaultIndex: r,
    index: n,
    allowMultiple: o,
    allowToggle: i,
    ...s
  } = e;
  Fo(e), Mo(e);
  const d = No(), [l, u] = F(-1);
  ce(() => () => {
    u(-1);
  }, []);
  const [c, p] = ir({
    value: n,
    defaultValue() {
      return o ? r ?? [] : r ?? -1;
    },
    onChange: t
  });
  return {
    index: c,
    setIndex: p,
    htmlProps: s,
    getAccordionItemProps: (f) => {
      let g = !1;
      return f !== null && (g = Array.isArray(c) ? c.includes(f) : c === f), { isOpen: g, onChange: (v) => {
        if (f !== null)
          if (o && Array.isArray(c)) {
            const y = v ? c.concat(f) : c.filter((k) => k !== f);
            p(y);
          } else
            v ? p(f) : i && p(-1);
      } };
    },
    focusedIndex: l,
    setFocusedIndex: u,
    descendants: d
  };
}
var [Do, Qe] = oe({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function jo(e) {
  const { isDisabled: t, isFocusable: r, id: n, ...o } = e, { getAccordionItemProps: i, setFocusedIndex: s } = Qe(), d = ne(null), l = Ge(), u = n ?? l, c = `accordion-button-${u}`, p = `accordion-panel-${u}`;
  Lo(e);
  const { register: h, index: f, descendants: g } = Ao({
    disabled: t && !r
  }), { isOpen: b, onChange: v } = i(
    f === -1 ? null : f
  );
  Wo({ isOpen: b, isDisabled: t });
  const y = () => {
    v == null || v(!0);
  }, k = () => {
    v == null || v(!1);
  }, T = P(() => {
    v == null || v(!b), s(f);
  }, [f, s, b, v]), A = P(
    (O) => {
      const W = {
        ArrowDown: () => {
          const D = g.nextEnabled(f);
          D == null || D.node.focus();
        },
        ArrowUp: () => {
          const D = g.prevEnabled(f);
          D == null || D.node.focus();
        },
        Home: () => {
          const D = g.firstEnabled();
          D == null || D.node.focus();
        },
        End: () => {
          const D = g.lastEnabled();
          D == null || D.node.focus();
        }
      }[O.key];
      W && (O.preventDefault(), W(O));
    },
    [g, f]
  ), z = P(() => {
    s(f);
  }, [s, f]), V = P(
    function($ = {}, W = null) {
      return {
        ...$,
        type: "button",
        ref: le(h, d, W),
        id: c,
        disabled: !!t,
        "aria-expanded": !!b,
        "aria-controls": p,
        onClick: L($.onClick, T),
        onFocus: L($.onFocus, z),
        onKeyDown: L($.onKeyDown, A)
      };
    },
    [
      c,
      t,
      b,
      T,
      z,
      A,
      p,
      h
    ]
  ), B = P(
    function($ = {}, W = null) {
      return {
        ...$,
        ref: W,
        role: "region",
        id: p,
        "aria-labelledby": c,
        hidden: !b
      };
    },
    [c, b, p]
  );
  return {
    isOpen: b,
    isDisabled: t,
    isFocusable: r,
    onOpen: y,
    onClose: k,
    getButtonProps: V,
    getPanelProps: B,
    htmlProps: o
  };
}
function Fo(e) {
  const t = e.index || e.defaultIndex, r = t != null && !Array.isArray(t) && e.allowMultiple;
  he({
    condition: !!r,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof t},`
  });
}
function Mo(e) {
  he({
    condition: !!(e.allowMultiple && e.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function Lo(e) {
  he({
    condition: !!(e.isFocusable && !e.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function Wo(e) {
  he({
    condition: e.isOpen && !!e.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}
function zo(e) {
  const { isOpen: t, isDisabled: r } = Ze(), { reduceMotion: n } = Qe(), o = M("chakra-accordion__icon", e.className), i = Re(), s = {
    opacity: r ? 0.4 : 1,
    transform: t ? "rotate(-180deg)" : void 0,
    transition: n ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...i.icon
  };
  return /* @__PURE__ */ m.jsx(
    $t,
    {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: o,
      __css: s,
      ...e,
      children: /* @__PURE__ */ m.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        }
      )
    }
  );
}
zo.displayName = "AccordionIcon";
var Vo = N(
  function(t, r) {
    const { children: n, className: o } = t, { htmlProps: i, ...s } = jo(t), l = {
      ...Re().container,
      overflowAnchor: "none"
    }, u = re(() => s, [s]);
    return /* @__PURE__ */ m.jsx(Po, { value: u, children: /* @__PURE__ */ m.jsx(
      w.div,
      {
        ref: r,
        ...i,
        className: M("chakra-accordion__item", o),
        __css: l,
        children: typeof n == "function" ? n({
          isExpanded: !!s.isOpen,
          isDisabled: !!s.isDisabled
        }) : n
      }
    ) });
  }
);
Vo.displayName = "AccordionItem";
var ye = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, kt = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.exit
  })
}, Go = (e) => e != null && parseInt(e.toString(), 10) > 0, xt = {
  exit: {
    height: { duration: 0.2, ease: ye.ease },
    opacity: { duration: 0.3, ease: ye.ease }
  },
  enter: {
    height: { duration: 0.3, ease: ye.ease },
    opacity: { duration: 0.4, ease: ye.ease }
  }
}, Ho = {
  exit: ({
    animateOpacity: e,
    startingHeight: t,
    transition: r,
    transitionEnd: n,
    delay: o
  }) => {
    var i;
    return {
      ...e && { opacity: Go(t) ? 1 : 0 },
      height: t,
      transitionEnd: n == null ? void 0 : n.exit,
      transition: (i = r == null ? void 0 : r.exit) != null ? i : kt.exit(xt.exit, o)
    };
  },
  enter: ({
    animateOpacity: e,
    endingHeight: t,
    transition: r,
    transitionEnd: n,
    delay: o
  }) => {
    var i;
    return {
      ...e && { opacity: 1 },
      height: t,
      transitionEnd: n == null ? void 0 : n.enter,
      transition: (i = r == null ? void 0 : r.enter) != null ? i : kt.enter(xt.enter, o)
    };
  }
}, Ht = _t(
  (e, t) => {
    const {
      in: r,
      unmountOnExit: n,
      animateOpacity: o = !0,
      startingHeight: i = 0,
      endingHeight: s = "auto",
      style: d,
      className: l,
      transition: u,
      transitionEnd: c,
      ...p
    } = e, [h, f] = F(!1);
    ce(() => {
      const k = setTimeout(() => {
        f(!0);
      });
      return () => clearTimeout(k);
    }, []), he({
      condition: Number(i) > 0 && !!n,
      message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    const g = parseFloat(i.toString()) > 0, b = {
      startingHeight: i,
      endingHeight: s,
      animateOpacity: o,
      transition: h ? u : { enter: { duration: 0 } },
      transitionEnd: {
        enter: c == null ? void 0 : c.enter,
        exit: n ? c == null ? void 0 : c.exit : {
          ...c == null ? void 0 : c.exit,
          display: g ? "block" : "none"
        }
      }
    }, v = n ? r : !0, y = r || n ? "enter" : "exit";
    return /* @__PURE__ */ m.jsx(lr, { initial: !1, custom: b, children: v && /* @__PURE__ */ m.jsx(
      cr.div,
      {
        ref: t,
        ...p,
        className: M("chakra-collapse", l),
        style: {
          overflow: "hidden",
          display: "block",
          ...d
        },
        custom: b,
        variants: Ho,
        initial: n ? "exit" : !1,
        animate: y,
        exit: "exit"
      }
    ) });
  }
);
Ht.displayName = "Collapse";
var qo = N(
  function(t, r) {
    const { className: n, motionProps: o, ...i } = t, { reduceMotion: s } = Qe(), { getPanelProps: d, isOpen: l } = Ze(), u = d(i, r), c = M("chakra-accordion__panel", n), p = Re();
    s || delete u.hidden;
    const h = /* @__PURE__ */ m.jsx(w.div, { ...u, __css: p.panel, className: c });
    return s ? h : /* @__PURE__ */ m.jsx(Ht, { in: l, ...o, children: h });
  }
);
qo.displayName = "AccordionPanel";
var Yo = N(function({ children: t, reduceMotion: r, ...n }, o) {
  const i = Te("Accordion", n), s = ie(n), { htmlProps: d, descendants: l, ...u } = $o(s), c = re(
    () => ({ ...u, reduceMotion: !!r }),
    [u, r]
  );
  return /* @__PURE__ */ m.jsx(Eo, { value: l, children: /* @__PURE__ */ m.jsx(Do, { value: c, children: /* @__PURE__ */ m.jsx(Bo, { value: i, children: /* @__PURE__ */ m.jsx(
    w.div,
    {
      ref: o,
      ...d,
      className: M("chakra-accordion", n.className),
      __css: i.root,
      children: t
    }
  ) }) }) });
});
Yo.displayName = "Accordion";
export {
  Yo as A,
  Ft as B,
  fo as C,
  Ln as F,
  Fn as H,
  bo as I,
  Ke as S,
  $n as T,
  jn as V,
  Vo as a,
  Oo as b,
  zo as c,
  qo as d,
  Lt as e,
  ia as f,
  aa as g,
  Vt as h,
  sa as i,
  ua as j,
  Gn as k,
  oa as l,
  En as m,
  da as u
};
